import React from 'react';



const Gallery = () => {
    return (
        <div className='mt-6'>
            <h1 className="text-3xl text-center text-primary font-bold">PRODUCE <span className="text-black">GALLERY</span></h1>
            <section className="overflow-hidden">
                <div className="max-w-screen-xl px-5 py-20 mx-auto ">
                    <div className="flex flex-wrap -m-1 md:-m-2">
                        <div className="flex flex-wrap w-1/2">
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-cover  object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/6rCV1sG/mozahid11111111111111111.jpg" />
                            </div>
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/dMPWdzZ/5.jpg" />
                            </div>
                            <div className="w-full p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/tbzV6kD/iamge3333333333333333.jpg" />
                            </div>
                            <div className="w-full p-1 md:p-2">
          
                      <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="  https://i.ibb.co/dMPWdzZ/5.jpg " />
                            </div>
                        </div>
                        <div className="flex flex-wrap w-1/2">
                            <div className="w-full p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="  https://i.ibb.co/dMPWdzZ/5.jpg 
                                    " />
                            </div>
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="
                                    https://i.ibb.co/pdJHwhL/mozahid2222222222222222.jpg" />
                            </div>
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/pdJHwhL/mozahid2222222222222222.jpg" />
                            </div>
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/pdJHwhL/mozahid2222222222222222.jpg" />
                            </div>
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/pdJHwhL/mozahid2222222222222222.jpg" />
                            </div>
                            <div className="w-1/2 p-1 md:p-2">
                                <img alt="gallery" className="block object-cover object-center w-full h-full rounded-lg"
                                    src="https://i.ibb.co/pdJHwhL/mozahid2222222222222222.jpg" />
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default Gallery;